import { Grid, TextField } from '@mui/material'

interface AbsenceCommentsErrorsProps {
  comments?: boolean
}

interface AbsenceCommentsProps {
  comments: string
  setComments: React.Dispatch<React.SetStateAction<string>>
  contactComments: string
  setContactComments: React.Dispatch<React.SetStateAction<string>>
  wfmComments?: string
  errors: AbsenceCommentsErrorsProps
}

function AbsenceComments({
  comments,
  setComments,
  contactComments,
  setContactComments,
  wfmComments,
  errors
}: AbsenceCommentsProps) {
  return (
    <>
      <Grid item xs={12} md={12}>
        <TextField
          fullWidth
          label="Contact Comments"
          rows={5}
          multiline
          value={contactComments}
          onChange={event => {
            const newValue = event.target.value
            setContactComments(newValue)
          }}
          name="contactComments"
        />
      </Grid>
      {Boolean(wfmComments) && (
        <Grid item xs={12} md={12}>
          <TextField
            disabled
            fullWidth
            label="WFM Comments"
            rows={5}
            multiline
            value={wfmComments}
            name="wfmComments"
          />
        </Grid>
      )}
      <Grid item xs={12} md={12}>
        <TextField
          fullWidth
          label="Comments"
          rows={5}
          multiline
          value={comments}
          error={errors.comments}
          onChange={event => {
            const newValue = event.target.value
            setComments(newValue)
          }}
          name="comments"
        />
      </Grid>
    </>
  )
}

export default AbsenceComments
